import '../styles/localNavigation.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import * as items from './localNavigationItems';
import { innerWidth } from '../../../shared/modules/frames';

var localNavigationInstance;

/**
 * A cache to store all models having ids in the Local Navigation config.
 */
function ItemCache() {
    this.cache = {};
}

$.extend(ItemCache.prototype, {
    /**
     * Adds (id, object) pairs to the cache where id is of type string.
     * Checks duplicate ids and throws JS error if duplicate found.
     */
    add: function (id, obj) {
        if (id === undefined) {
            throw 'ID is undefined. Please, check the stacktrace for the root cause.';
        }
        if (this.cache[id] !== undefined) {
            throw 'Duplicate id found: ' + id;
        }
        this.cache[id] = obj;
    },

    get: function (id, requiredType) {
        var foundItem = this.cache[id];
        return (foundItem && foundItem instanceof requiredType) ? foundItem : undefined;
    },

    /**
     * Returns the active item - active status check based on the model.
     * Please note that it works only during Local Navigation initialization.
     */
    getActiveItem: function () {
        var key;
        for (key in this.cache) {
            if (this.cache.hasOwnProperty(key) && this.cache[key].active) {
                return this.cache[key];
            }
        }
    }
});

function resolveConfigItem(item, defaultValue) {
    return item !== undefined ? item : defaultValue;
}

/**
 * Represents a Local Navigation widget in the actual window frame.
 * @param {object} clientConfig The configuration object provided by the client. For details please check the API
 * documentation of the Local Navigation widget.
 */
function LocalNavigation(clientConfig) {
    var activeItem,
        self = this;

    this.$markup = $(clientConfig.targetElem);
    // Clone so that the original one is not modified
    this.config = $.extend(true, {}, clientConfig);
    this.iconPanel = null; // Will be set later
    this.itemCache = new ItemCache();

    this.setDefaults(this.config);
    this.pageGroups = this.generatePageGroupsModel(this.config);
    this.iconPanel = this.generateIconPanelModel(this.config);

    this.cssConfig = {};
    this.setCssClassesForAnimations(this.cssConfig);
    this.render(this.$markup);
    this.adjustCollapse();
    $(window).on('resize', function () {
        self.adjustCollapse();
    });

    // Display active item or pagegroup
    activeItem = this.itemCache.getActiveItem();
    if (activeItem) {
        this.select(activeItem.id);
    }

}

$.extend(LocalNavigation.prototype, {
    adjustCollapse: function () {
        this.collapsible = this.isCollapsible();
        this.setCssClassesForCollapsibility();
        this.adjustViewDimensions();
    },

    setCssClassesForCollapsibility: function () {
        if (this.collapsible) {
            this.$markup.addClass(this.cssConfig.collapsible);
        } else {
            this.$markup.removeClass(this.cssConfig.collapsible + ' ' + this.cssConfig.collapsed);
            this.$markup.addClass(this.cssConfig.expanded);
        }
    },

    isCollapsible: function () {
        return innerWidth(window) < this.config.minimizingThreshold;
    },

    expandOrCollapse: function () {
        $(this.$markup).toggleClass(this.cssConfig.collapsed + ' ' + this.cssConfig.expanded);
    },

    setDefaults: function (config) {
        config.animations = resolveConfigItem(config.animations, {});
        config.animations.enable = resolveConfigItem(config.animations.enable, true);
        config.animations.showOnStart = resolveConfigItem(config.animations.showOnStart, true);
        config.minimizingThreshold = resolveConfigItem(config.minimizingThreshold, 1253);
        config.hoverPreview = resolveConfigItem(config.hoverPreview, 'none');
        config.enableFilter = resolveConfigItem(config.enableFilter, true);
    },

    setCssClassesForAnimations: function (cssConfig) {
        cssConfig.collapsible = 'uwr-local-nav-collapsible';
        cssConfig.expanded = 'uwr-local-nav-expanded';
        cssConfig.collapsed = 'uwr-local-nav-collapsed';
        if (!(common.isIe7() || common.isIe8() || common.isIe9())) {
            cssConfig.expanded += '-animation';
            cssConfig.collapsed += '-animation';
        }
    },

    generatePageGroupsModel: function (config) {
        var pageGroups = [],
            pageGroupConfig,
            i;
        for (i = 0; i < config.pageGroups.length; i++) {
            pageGroupConfig = config.pageGroups[i];
            pageGroupConfig.parentObject = this;
            pageGroupConfig.rootObject = this;
            pageGroups.push(new items.PageGroup(pageGroupConfig));
        }
        return pageGroups;
    },

    generateIconPanelModel: function (config) {
        config.parentObject = this;
        config.rootObject = this;
        return new items.IconPanel(config);
    },

    render: function ($markup) {
        var i,
            self = this;
        this.iconPanel.render($markup);
        for (i = 0; i < this.pageGroups.length; i++) {
            this.pageGroups[i].render($markup);
        }
        $markup.addClass(this.cssConfig.expanded);
        $('.uwr-local-nav-hamburger-icon', $markup).on('click', function () {
            self.expandOrCollapse();
        });
    },

    adjustViewDimensions: function () {
        var pageGroupWidth = 0,
            $iconPanel = $('.uwr-local-nav-iconpanel', this.$markup),
            iconPanelWidth = $iconPanel.width(),
            iconPanelHeight = $iconPanel.height(),
            largestHeight = iconPanelHeight;
        $('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            $(this).height('auto');
        });
        $('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            var height = $(this).height(),
                width = $(this).width();
            pageGroupWidth = Math.max(width, pageGroupWidth);
            largestHeight = Math.max(height, largestHeight);
        });
        pageGroupWidth = this.collapsible ? 0 : pageGroupWidth;
        this.$markup.height(largestHeight);
        this.$markup.width(iconPanelWidth + pageGroupWidth);
        $('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            $(this).height(largestHeight);
        });
    },

    enable: function (id) {
        var node = this.itemCache.get(id, items.Node);
        if (node) {
            node.setEnabled();
        }
    },

    disable: function (id) {
        var node = this.itemCache.get(id, items.Node);
        if (node) {
            node.setEnabled(false);
        }
    },

    select: function (id) {
        var node = this.itemCache.get(id, items.Node),
            parent,
            i;
        // if the item is a node
        if (node) {
            // activate id within the whole page group
            for (i = 0; i < this.pageGroups.length; i++) {
                this.pageGroups[i].setActive(id);
            }

            // show the item's page group
            parent = node;
            while (!(parent instanceof items.PageGroup)) {
                parent = parent.getParent();
            }
            this.show(parent.id);
        } else {
            // if item is page group or invalid
            this.show(id);
        }
    },

    deselect: function (id) {
        var node = this.itemCache.get(id, items.Node);
        if (node) {
            node.setActive(id, false);
        }
    },

    show: function (id) {
        var i,
            pageGroup;
        if (id) {
            // adjust page groups
            for (i = 0; i < this.pageGroups.length; i++) {
                pageGroup = this.pageGroups[i];
                if (pageGroup.id === id) {
                    pageGroup.show(this.$markup);
                } else {
                    pageGroup.hide();
                    pageGroup.setActive(id);
                }
            }
            // adjust icon panel
            this.iconPanel.setActive(id);
        } else {
            this.$markup.removeClass('uwr-local-nav-hidden');
        }
    },

    hide: function (id) {
        var pageGroup;
        if (id) {
            pageGroup = this.itemCache.get(id, items.PageGroup);
            if (pageGroup) {
                pageGroup.hide();
            }
        } else {
            this.$markup.addClass('uwr-local-nav-hidden');
        }
    }
});

export function init(callback) {
    var $markup = $('.uwr-local-nav').first(),
        config = common.resolveConfig($markup, 'config');

    config.targetElem = $markup.get(0);

    if (config.targetElem) {
        localNavigationInstance = new LocalNavigation(config);
    }

    common.invoke(callback);
}

export function deselect(id, callback) {
    localNavigationInstance.deselect(id);
    common.invoke(callback);
}

export function disable(id, callback) {
    localNavigationInstance.disable(id);
    common.invoke(callback);
}

export function enable(id, callback) {
    localNavigationInstance.enable(id);
    common.invoke(callback);
}

export function hide(idOrCallback, callback) {
    if ($.isFunction(idOrCallback)) {
        localNavigationInstance.hide();
        common.invoke(idOrCallback);
    } else {
        localNavigationInstance.hide(idOrCallback);
        common.invoke(callback);
    }
}

export function select(id, callback) {
    localNavigationInstance.select(id);
    common.invoke(callback);
}

export function show(idOrCallback, callback) {
    if ($.isFunction(idOrCallback)) {
        localNavigationInstance.show();
        common.invoke(idOrCallback);
    } else {
        localNavigationInstance.show(idOrCallback);
        common.invoke(callback);
    }
}



//////////////////
// WEBPACK FOOTER
// ./widgets/LocalNavigation/js/localNavigation.js
// module id = 11
// module chunks = main